<template>
  <div class="user">
    <CreateOrEditAdminRaise
      ref="createOrEditDialog"
      @submitDialog="GetTableList"
    />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>钢厂拼单</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="HeaderButtons">
        <el-button
          v-if="$store.getters.checkPermission('admin_raise.add')"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="CreateItem()"
          >发布拼单</el-button
        >
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="4">
          <label>code</label>
          <el-input
            placeholder="请输入code"
            v-model="SearchData.code"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <label>{{ l("名称") }}</label>
          <el-input
            placeholder="请输入名称"
            v-model="SearchData.title"
            clearable
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>

        <el-col :span="4">
          <label>{{ l("状态") }}</label>
          <el-select
            clearable
            v-model="SearchData.status"
            @change="GetTableList(true)"
          >
            <el-option
              v-for="item of statusList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            @click="GetTableList(true)"
            >{{ l("查询") }}</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) => true,
              label: l('详情'),
              command: 'ViewItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />
        <el-table-column
          prop="title"
          :label="l('标题')"
          min-width="200"
          show-overflow-tooltip
          fixed
        >
        </el-table-column>

        <el-table-column :label="l('状态')" width="150">
          <template slot-scope="scope">
            <span
              :class="[
                $utils.listFilter(statusList, scope.row.status, 'class'),
              ]"
            >
              {{ $utils.listFilter(statusList, scope.row.status) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="l('截止日期')" width="120">
          <template slot-scope="scope">
            {{ scope.row.expire_time && scope.row.expire_time.slice(0, 10) }}
          </template>
        </el-table-column>

        <el-table-column label="拼单进度" width="150">
          <template slot-scope="scope">
            {{ scope.row.rate_amount }} / {{ scope.row.amount }}
            {{ scope.row.unit }}
          </template>
        </el-table-column>

        <el-table-column label="参与情况" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.auth_count &&
                ($store.getters.checkRole(3001) ||
                  $store.getters.checkRole(3002) ||
                  $store.getters.checkRole(30051))
              "
              class="ViewLink"
              @click="showBusiness(scope.row)"
              >{{ scope.row.auth_count }}家已参与</span
            >
            <span v-else-if="scope.row.auth_count"
              >{{ scope.row.auth_count }}家已参与</span
            >
            <span v-else style="color: #999">暂无参与</span>
          </template>
        </el-table-column>

        <el-table-column
          label="推广"
          width="80"
          prop="recommend_level"
          sortable="custom"
        >
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.recommend_level"
              :true-label="1"
              :false-label="0"
              :disabled="
                !$store.getters.checkPermission('admin_raise.recommend')
              "
              @change="changeRecommend(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>

        <el-table-column
          prop="created_time"
          label="发布时间"
          sortable="custom"
          width="170"
        >
          <template slot-scope="scope">
            {{ scope.row.created_time }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
    <el-dialog
      title="拼单记录"
      :visible.sync="businessDialogVisible"
      :destroy-on-close="true"
      width="1200px"
    >
      <BusinessList v-if="businessDialogVisible" :api_url="business_api_url" :showOperation="true" :manager_shichangList="manager_shichangList" :nowShowBusinessRow="nowShowBusinessRow"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="businessDialogVisible = false">{{
          l("取 消")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditAdminRaise from "./operation/CreateOrEditAdminRaise.vue";
import BusinessList from "@/components/common/BusinessList.vue";

export default {
  name: "AdminSellerRaise",
  components: {
    CreateOrEditAdminRaise,
    BusinessList,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        code: "",
        title: "",
        status: null,
      },
      statusList: [
        {
          id: -1,
          name: this.l("已下架"),
          class: "color-danger",
        },
        {
          id: 1,
          name: "进行中",
          class: "color-success",
        },
        {
          id: 2,
          name: "已结束",
          class: "color-warning",
        },
      ],

      business_api_url: "",
      businessDialogVisible: false,

      manager_shichangList: [],

      nowShowBusinessRow: null,//目前正在展示BusinessList的row

    };
  },
  mounted() {
    if (this.$route.query.status != null) {
      this.SearchData.status = this.$route.query.status;
    }

    this.axios
      .get("/api/admin_user/backend_user_simple_list/", {
        params: {
          role: "3004,30041"
        },
      })
      .then((data) => {
        this.manager_shichangList = data;
      });
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/admin_raise/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            item.img_array = JSON.parse(item.img_array);
            return item;
          });
        });
    },
    changeRecommend(item) {
      this.$confirm(
        `是否${item.recommend_level ? "推广" : "解除推广"}【${item.title}】?`,
        "",
        {
          type: "warning",
        }
      )
        .then(() => {
          this.axios
            .put(`/api/admin_raise/${item.code}/recommend/`, {
              recommend_level: item.recommend_level,
            })
            .then((response) => {
              this.GetTableList();
            })
            .catch(() => {
              this.GetTableList();
            });
        })
        .catch(() => {
          this.GetTableList();
        });
    },
    showBusiness(item) {
      this.nowShowBusinessRow = item;
      this.business_api_url = `/api/admin_raise/${item.code}/business_list/`;
      this.businessDialogVisible = true;
    },
  },
};
</script>


<style scoped lang="scss">
</style>

